import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppBarComponent, AppBarContactComponent, AppFooterComponent, AppPageComponent } from "common";
import { SignUpGuard } from "../../infrastructure/guards/sign-up.guard";
import { SignUpComponent } from "./sign-up.component";

const routes: Routes = [
  {
    path: "sign-up",
    component: AppPageComponent,
    canActivate: [SignUpGuard],
    data: {
      appPage: {
        contentWithoutPadding: true,
        contentClass: "simple",
      },
      appBar: {
        logoSize: "logo-s",
        stickyDisabled: true,
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "right",
            component: AppBarContactComponent,
          },
        ],
      },
      {
        path: "",
        component: SignUpComponent,
      },
      {
        path: "",
        outlet: "app-footer",
        component: AppFooterComponent,
        data: {
          appFooter: {
            full: true,
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignUpRoutingModule { }
